import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/home/frontru/nesterenko/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/frontru/nesterenko/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/components/entities/customization/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/views/catalog/_components/catalog-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/catalog/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/catalog/_components/hero-heading/index.module.scss");
